import { useOutletContext } from "react-router-dom";
import "./analytics.css";
import AdvisorFeedback from "./components/AdvisorFeedback";
import AnalyticHeader from "./components/AnalyticHeader";
import CommissionChart from "./components/CommissionChart";
import ReferralSource from "./components/ReferralSource";
import StatsCards from "./components/StatsCards";

export default function Analytics() {
  const { openSidebar } = useOutletContext();
  return (
    <div className="rp-analytics-container">
      <AnalyticHeader onMenuClick={openSidebar}/>
        <div className="rp-analytics-div">
          <StatsCards />
          <div className="rp-analytics-grid">
            <CommissionChart />
            <ReferralSource />
          </div>
        </div>

      <AdvisorFeedback />
    </div>
  );
}
